module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n      Journey: " + _vm._s(this.$route.query.journey_name) + "\n    ")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-12 col-sm-12 col-md-12"
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-rounded btn-nudge",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addStageMapping
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" Add New Stage Mapping\n          ")])])])]), _vm._v(" "), _vm._l((_vm.mappingList), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "panel panel-default panel-group-container"
    }, [_c('div', {
      staticClass: "panel-body"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12 col-lg-12 col-xs-12 keyword-conversation-container"
    }, [_c('div', {
      staticClass: "form-group col-xs-5 col-sm-5 col-md-5"
    }, [_c('label', [_vm._v("Stage")]), _vm._v(" "), _c('nv-select', {
      staticClass: "form-control",
      attrs: {
        "id": "stage",
        "name": "stage"
      },
      model: {
        value: (item.stage),
        callback: function($$v) {
          _vm.$set(item, "stage", $$v)
        },
        expression: "item.stage"
      }
    }, [_c('option', {
      attrs: {
        "value": "null"
      }
    }, [_vm._v("--No Stage--")]), _vm._v(" "), _vm._l((_vm.stages), function(data, index) {
      return _c('option', {
        key: index,
        domProps: {
          "value": data
        }
      }, [_vm._v(_vm._s(data))])
    })], 2)], 1), _vm._v(" "), _c('div', {
      staticClass: "form-group col-xs-5 col-sm-5 col-md-5"
    }, [_c('label', [_vm._v("Scout Menu")]), _vm._v(" "), _c('treeselect', {
      attrs: {
        "placeholder": "--Choose a conversation--",
        "disabled": !!item.keyword_id,
        "multiple": false,
        "options": _vm.conversationList
      },
      model: {
        value: (item.content_id),
        callback: function($$v) {
          _vm.$set(item, "content_id", $$v)
        },
        expression: "item.content_id"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "form-group col-xs-2 col-sm-2 col-md-2"
    }, [_c('button', {
      staticClass: "btn btn-rounded btn-remove-nudge btn-nudge btn-primary col-xs-2 col-sm-2 col-md-2 col-2",
      staticStyle: {
        "margin-right": "5px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.saveMapping(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-save",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-rounded btn-remove-nudge btn-nudge btn-danger col-xs-2 col-sm-2 col-md-2 col-2",
      staticStyle: {
        "margin-right": "5px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeMapping(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-minus",
      attrs: {
        "aria-hidden": "true"
      }
    })])])])])])])])
  })], 2), _vm._v(" "), (_vm.isDeleteConfirmationVisible) ? _c('deleteConfirmationModal', {
    attrs: {
      "isDeleteConfirmationVisible": _vm.isDeleteConfirmationVisible,
      "confirmationMessage": _vm.confirmationMessage,
      "actionToBePerformed": _vm.actionToBePerformed
    },
    on: {
      "close": _vm.closeConfirmationModal,
      "deleteMappingFromDB": _vm.deleteMappingFromDB
    }
  }) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('BlockUI', [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  }), _c('br'), _vm._v("Please wait...")]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', [_vm._v(" Scout JOR Mappings")]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "scout_jor_list"
    }
  }, [_vm._v(" Mapping List")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Mapping Detail")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-df8850ea","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/scout-JOR-mapping/scoutJORMappingDetails.vue
// module id = 0lVB
// module chunks = 1